import dayjs from "dayjs";

export const formatMoney = (value) =>
    Number(value || 0).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 });

export const formatBookedDate = (value) => {
    if (!value) return "";
    const parsed = dayjs(value);
    return parsed.isValid() ? parsed.format("MMM D, YYYY") : "";
};

export const formatTripDateTime = (value) => {
    if (!value) return "—";
    const parsed = dayjs(value);
    return parsed.isValid() ? parsed.format("ddd, MMM D [at] h:mmA") : "—";
};

export const getCarDisplayName = (reservation) =>
    reservation?.carSelected?.carName?.trim() ||
    reservation?.carName?.trim() ||
    reservation?.carType?.trim() ||
    "Vehicle";

export const getTotalPaid = (reservation) => {
    const invoice = reservation?.invoice || {};
    const deposit = Number(invoice.deposit);
    if (!Number.isNaN(deposit) && deposit >= 0 && invoice.deposit != null) {
        return Math.max(0, deposit);
    }

    const events = Array.isArray(invoice.paymentEvent) ? invoice.paymentEvent : [];
    const paidFromEvents = events.reduce((sum, event) => {
        if (event?.status !== "success") return sum;
        return sum + Math.max(0, Number(event?.amount) || 0);
    }, 0);
    if (paidFromEvents > 0) return paidFromEvents;

    return Number(invoice.total) || 0;
};

export const getInvoiceTotal = (reservation) => Number(reservation?.invoice?.total) || 0;

export const getInvoiceDue = (reservation) => {
    const invoice = reservation?.invoice || {};
    if (typeof invoice.due === "number" && !Number.isNaN(invoice.due)) {
        return Math.max(0, invoice.due);
    }
    return Math.max(0, getInvoiceTotal(reservation) - getTotalPaid(reservation));
};

export const getReservationLocationLabel = (reservation, locations = []) => {
    const location = reservation?.pickupLocation;
    if (location && typeof location === "object") {
        const address = String(location.address || "").trim();
        const city = String(location.city || "").trim();
        const state = String(location.state || "").trim();
        const zip = String(location.zip || location.zipCode || location.postalCode || "").trim();
        const cityLine = [city && state ? `${city}, ${state}` : city || state, zip].filter(Boolean).join(" ");
        const lines = [address, cityLine].filter(Boolean);
        if (lines.length) return lines.join(", ");
    }

    if (typeof location === "string" && location) return location;

    const locationId = location?._id || location?.id;
    if (locationId && locations.length) {
        const match = locations.find((loc) => (loc._id || loc.id) === locationId);
        if (match) {
            const city = String(match.city || "").trim();
            const state = String(match.state || "").trim();
            if (city && state) return `${city}, ${state}`;
            return match.name || match.address || "";
        }
    }

    return "—";
};

export const isBeforeScheduledPickup = (reservation) => {
    const raw = reservation?.exactPickupTime || reservation?.pickupDate;
    if (!raw) return false;
    const pickup = dayjs(raw);
    return pickup.isValid() && dayjs().isBefore(pickup);
};
